import jwtDecode from 'jwt-decode'
import securityConfig from '~/config/security-config.yaml'
export default async function ({ store, redirect, app, route }) {
  // Use route.query instead of direct DOM access
  const params = route.query ? '?' + new URLSearchParams(route.query).toString() : ''

  // Check if session cookie exists
  if (!app.$cookies.get('__session')) {
    app.$cookies.remove('__session')
    store.commit("setCurrentUser", null)
    return redirect('/login' + params)
  }

  try {
    const token = app.$cookies.get('__session')
    const decodedToken = jwtDecode(token)

    // Validate token expiration
    const currentTime = Math.floor(Date.now() / 1000)
    if (decodedToken.exp && decodedToken.exp < currentTime) {
      console.warn('Admin token expired, redirecting to login')
      app.$cookies.remove('__session')
      store.commit("setCurrentUser", null)
      return redirect('/login' + params)
    }

    // Validate required token fields
    if (!decodedToken.user_id || !decodedToken.email) {
      console.error('Invalid admin token structure')
      app.$cookies.remove('__session')
      store.commit("setCurrentUser", null)
      return redirect('/login' + params)
    }

    const uid = decodedToken.user_id
    const email = decodedToken.email

    store.commit("setCurrentUser", { email, uid })

    // Fetch user profile
    await store.dispatch('fetchUserProfile')

    if (!store.state.userProfile) {
      console.warn('Admin user profile not found')
      return redirect('/login' + params)
    }
  } catch (error) {
    // Handle JWT decode errors
    console.error('Admin authentication error:', error.message)
    app.$cookies.remove('__session')
    store.commit("setCurrentUser", null)
    return redirect('/login' + params)
  }

  // Validate current user exists
  if (!store || !store.state || !store.state.currentUser) {
    return redirect('/login' + params)
  }

  // Validate admin privileges using securityConfig rules
  const userRoles = store.state.userProfile.roles || [];
  const adminDefinition = securityConfig.roles.admin;
  const founderDefinition = securityConfig.roles.founder;
  
  const hasAdminOverride = founderDefinition.override_rules && userRoles.includes("founder");
  const hasAdminRole = userRoles.includes("admin");

  if (!hasAdminOverride && !hasAdminRole && !app.$util.isTesting() && !app.$util.isFounder(store.state.userProfile)) {
    console.warn('Unauthorized admin access attempt:', store.state.currentUser.email)
    return redirect('/login' + params)
  }
}


